package com.wintermar.inspection.feature.presentation.template.widget.preview

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor

@Composable
fun PageHeader(
    title: String,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    color: ThemeColor = LocalAppTheme.current.color
) {
    Column(
        modifier = Modifier.fillMaxWidth()
            .background(
                color = color.surface.neutral.subtle.default,
                shape = RoundedCornerShape(
                    topStart = dimension.radius.lg,
                    topEnd = dimension.radius.lg
                )
            )
            .padding(
                dimension.spacing.space2
            ),
    ) {
        TextBodySmall(
            title,
            modifier = Modifier.padding(dimension.spacing.space2)
        )
    }
}
